import React, { useState } from "react";
import {
  PaymentElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";

import Button from "components/Button";

interface StripeFormProps {
  onSuccess?: (...args: unknown[]) => void;
  showSkipButton?: boolean;
  onSkip?: (...args: unknown[]) => void;
  skippingPayment?: boolean;
}

const StripeForm = ({
  onSuccess,
  showSkipButton,
  onSkip,
  skippingPayment,
}: StripeFormProps) => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState<string | null | undefined>(
    null
  );
  const [submittingPayment, setSubmittingPayment] = useState(false);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();
    if (skippingPayment) return;

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }
    setSubmittingPayment(true);

    const { error, setupIntent } = await stripe.confirmSetup({
      //`Elements` instance that was used to create the Payment Element
      elements,
      redirect: "if_required",
      confirmParams: {
        return_url: window.location.href,
      },
    });

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      setErrorMessage(error.message);
    } else {
      onSuccess?.(setupIntent);
    }

    setSubmittingPayment(false);
  };
  return (
    <form onSubmit={(e) => void handleSubmit(e)}>
      <PaymentElement />

      {/* Show error message to your customers */}
      {errorMessage && <div>{errorMessage}</div>}
      <div className="submit-row">
        {showSkipButton && (
          <Button
            color={"action"}
            name={"cancel"}
            withArrow
            loading={skippingPayment}
            // skipping mid-confirmation would still save and charge the card once it succeeds
            disabled={submittingPayment}
            onClick={onSkip}
            // an invalid type falls back to submit, which would also confirm the setup intent and save the card
            type="button"
          >
            Setup Billing Details Later
          </Button>
        )}
        <Button
          name="submit"
          loading={submittingPayment}
          disabled={skippingPayment}
          withArrow
          btnLabel={"Submit"}
        />
      </div>
    </form>
  );
};

export default StripeForm;
